<template>
  <div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Shop kết nối
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <span style="font-weight: 700">{{ pack.shop_connect }} shop</span>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Công cụ từ khóa
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'keyword_tool')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Phân tích Insight
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'order_center')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Đấu thầu tự động
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'auto_campaign')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Chống click ảo
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'anti_click')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Tối ưu theo CIR
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'auto_cir')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Tối ưu theo Điều kiện
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'auto_campaign')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Đấu thầu theo vị trí Trung Bình
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'auto_campaign')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Flash sale nâng cao
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'flash_sale_advanced')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
    <div style="margin-bottom: 12px">
      <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
        Kế hoạch quảng cáo
      </div>
      <div style="display: inline-block; width: 28%; text-align: right">
        <i v-if="m__check_pack_marketing(pack, 'agency_plan')"
           style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
        <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pack: {
      type: Object,
      required: true
    }
  },

  methods: {
    m__check_pack_marketing(pack, field) {
      return pack.extra_data && pack.extra_data.marketing && pack.extra_data.marketing[field]
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/package/component/shopee_ads_component.vue